import { EventType, EventAssignmentCategory } from "@satyrsmc/shared/client";

export const FOOD_CATEGORIES = ["Food & Beverage", "Food", "Beverage"];
export const EVENT_DAYS = 4;

export const EVENT_TYPES = Object.values(EventType);

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  [EventType.Badger]: "Badger",
  [EventType.Social]: "Social",
  [EventType.PioneerRun]: "Pioneer Run",
  [EventType.Rides]: "Rides",
};

export const EVENT_ASSIGNMENT_CATEGORY_LABELS: Record<EventAssignmentCategory, string> = {
  [EventAssignmentCategory.Planning]: "Event Planning",
  [EventAssignmentCategory.During]: "During the Event",
};

export function isFoodCategory(category: string): boolean {
  return FOOD_CATEGORIES.includes(category);
}

const CAMPOUT_EVENT_TYPES = new Set<string>([
  EventType.Badger,
  EventType.Social,
  EventType.PioneerRun,
]);

/** Multi-day campout events that use GA/day-pass/member ticket pricing. */
export function isCampoutEvent(eventType: string | null | undefined): boolean {
  return !!eventType && CAMPOUT_EVENT_TYPES.has(eventType);
}

/** Ride events that use ride_cost and ride route details. */
export function isRideEvent(eventType: string | null | undefined): boolean {
  return eventType === EventType.Rides;
}

/** Badger campouts specifically — a stricter gate than {@link isCampoutEvent}. */
export function isBadgerEvent(eventType: string | null | undefined): boolean {
  return eventType === EventType.Badger;
}
